var map = {
	"./asset-hyperlink.json": 49075,
	"./blockquote.json": 15381,
	"./document.json": 37411,
	"./embedded-asset-block.json": 21923,
	"./embedded-entry-block.json": 74891,
	"./embedded-entry-inline.json": 44438,
	"./embedded-resource-block.json": 23297,
	"./embedded-resource-inline.json": 15505,
	"./entry-hyperlink.json": 10989,
	"./heading-1.json": 67551,
	"./heading-2.json": 88708,
	"./heading-3.json": 13691,
	"./heading-4.json": 9198,
	"./heading-5.json": 94822,
	"./heading-6.json": 97439,
	"./hr.json": 34363,
	"./hyperlink.json": 69197,
	"./list-item.json": 46805,
	"./ordered-list.json": 84887,
	"./paragraph.json": 1236,
	"./resource-hyperlink.json": 44227,
	"./table-cell.json": 56692,
	"./table-header-cell.json": 38698,
	"./table-row.json": 35821,
	"./table.json": 41738,
	"./text.json": 60072,
	"./unordered-list.json": 4044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4194;